import dayjs from 'dayjs';
import { CARE_CLIENT_VISITOR_STATE } from '@/interface/domain/careClientVisitor';
import apiErrorCode from '@/constant/error/api_errorCode.json';
import { mockOption } from './mockOption';
// ============= careClientVisitorProfile =============
const baseCareClientVisitorProfile = {
    _id: 'careClientVisitor-239817293125371612837',
    state: CARE_CLIENT_VISITOR_STATE.ACTIVE,
    c_at: '2023-11-20T02:00:00.000Z',
    entryPointTrackerId: 'af01927bc39ffads',
    marketingChannelList: [],
    contract: null,
    tappayCardTokenList: [],
};
// ============= timeSlotFeeData =============
const allDayTimeSlotFeeData = {
    hourlyFee: null,
    hourlyServiceFee: null,
    hourlyPlatformFee: null,
    dailyFee: 4510,
    dailyServiceFee: 4100,
    dailyPlatformFee: 410,
    expectedTotalFee: 31570,
    expectedTotalServiceFee: 28700,
    expectedTotalPlatformFee: 2870,
    extraChargeItemList: ['疥瘡', '隔離病床'],
};
const partTimeTimeSlotFeeData = {
    hourlyFee: 294,
    hourlyServiceFee: 267,
    hourlyPlatformFee: 27,
    dailyFee: null,
    dailyServiceFee: null,
    dailyPlatformFee: null,
    expectedTotalFee: 3525,
    expectedTotalServiceFee: 3204,
    expectedTotalPlatformFee: 321,
    extraChargeItemList: ['疥瘡', '隔離病床'],
};
// ============= API response =============
const defaultSuccess = {
    success: true,
};
// /api/careClientVisitor/init
export const careClientVisitorInitRes = {
    success: {
        ...defaultSuccess,
        data: {
            careClientVisitorId: 'careClientVisitor-239817293125371612837',
        },
    },
    error: {
        success: false,
        errorCode: apiErrorCode['careClientVisitor/init'].badParams.errorCode,
    },
};
// /api/client/profile/get
export const profileGetRes = {
    success: {
        default: {
            ...defaultSuccess,
            data: baseCareClientVisitorProfile,
        },
        stateIsEnd: {
            ...defaultSuccess,
            data: {
                ...baseCareClientVisitorProfile,
                state: CARE_CLIENT_VISITOR_STATE.END,
            },
        },
        hasContract: {
            ...defaultSuccess,
            data: {
                ...baseCareClientVisitorProfile,
                contract: '2023-11-20T02:00:00.000Z',
            },
        },
        hasMarketingChannelList: {
            ...defaultSuccess,
            data: {
                ...baseCareClientVisitorProfile,
                marketingChannelList: ['Google搜尋', '醫院實體廣告(海報、傳單)'],
            },
        },
        hasMarketingChannelListAndContract: {
            ...defaultSuccess,
            data: {
                ...baseCareClientVisitorProfile,
                marketingChannelList: ['Google搜尋', '醫院實體廣告(海報、傳單)'],
                contract: '2023-11-20T02:00:00.000Z',
            },
        },
    },
};
// /api/client/option/get
export const optionGetRes = {
    success: { ...defaultSuccess, data: mockOption },
};
// /api/client/profile/update
export const profileUpdateRes = {
    success: defaultSuccess,
};
// /api/client/journey/cache/put
export const journeyCachePutRes = {
    success: defaultSuccess,
};
export const paramVerifyRes = {
    success: defaultSuccess,
    error: {
        contactInfoPage: {
            success: false,
            errorCode: apiErrorCode['v6/client/order/param/verify'].badParams.errorCode,
            data: {
                errorTypes: ['contact.phone'],
            },
        },
        patientInfoPage: {
            success: false,
            errorCode: apiErrorCode['v6/client/order/param/verify'].badParams.errorCode,
            data: {
                errorTypes: ['patient.age', 'symptom'],
            },
        },
        careRequirementPage: {
            success: false,
            errorCode: apiErrorCode['v6/client/order/param/verify'].badParams.errorCode,
            data: {
                errorTypes: ['servedItem'],
            },
        },
    },
};
// /api/client/careOrderBaby/init
export const careOrderBabyInitRes = {
    success: {
        ...defaultSuccess,
        data: {
            code: 'AS03OAV1',
            expirationTime: dayjs().add(2, 'hour').toISOString(),
        },
    },
    error: {
        badParamsTimeSlotList: {
            success: false,
            errorCode: apiErrorCode['client/careOrderBaby/init'].badParams.errorCode,
            data: {
                errorTypes: ['timeSlotList'],
            },
        },
        careClientVisitorExpired: {
            success: false,
            errorCode: apiErrorCode['client/careOrderBaby/init'].careClientVisitorExpired.errorCode,
        },
        careClientVisitorAlreadyHasCareOrderBaby: {
            success: false,
            errorCode: apiErrorCode['client/careOrderBaby/init'].careClientVisitorAlreadyHasCareOrderBaby
                .errorCode,
        },
    },
};
// /api/client/order/timeSlot/fee/calculate
export const timeSlotFeeCalculateRes = {
    success: {
        allDay: {
            ...defaultSuccess,
            data: allDayTimeSlotFeeData,
        },
        partTime: {
            ...defaultSuccess,
            data: partTimeTimeSlotFeeData,
        },
    },
};
